import * as React from "react";
import { AppRoutes } from "./routes/Routes";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CssBaseline } from "@mui/material";
import useHealthCheck, {
  FullScreenCenter,
  Maintenance,
} from "./hooks/useHealthCheck";
import { API_GATEWAY, PR_DEP } from "./config/globalVariables";
import { Loader } from "@progress/kendo-react-indicators";

function App() {
  const [checking, healthy] = useHealthCheck(
    API_GATEWAY + PR_DEP + "/HealthCheck/health-check"
  );
  if (checking)
    return (
      <FullScreenCenter>
        <Loader size="large" type={"converging-spinner"} />
      </FullScreenCenter>
    );
  if (!healthy)
    return (
      <FullScreenCenter>
        <Maintenance />
      </FullScreenCenter>
    );

  return (
    <BrowserRouter>
      <CssBaseline />
      <Provider store={store}>
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Provider>
    </BrowserRouter>
  );
}
export default App;
